import axios from "axios";

// const baseUrl = `http://localhost:6760/`;
const baseUrl = `/`;



export const sendOTPApi = async (msisdn) => {
    const response = await axios.post(
        "https://api-mgbmoovgaming.uvcannproducts.com/OTP/sendOTP",
        {
            msisdn,
        }
    );

    return response;
};

export const verifyOTPApi = async (msisdn, otp) => {
    const response = await axios.post(
        "https://api-mgbmoovgaming.uvcannproducts.com/OTP/verifyOTP",
        {
            msisdn,
            otp,
        }
    );

    return response;
};

export const activateUserApi = async (msisdn, ext_ref, pack_type) => {
    const response = await axios.post(
        "https://api-mgbmoovgaming.uvcannproducts.com/activate-user",
        {
            msisdn,
            ext_ref,
            pack_type,
        }
    );

    return response;
};


export const deactivateUserApi = async (msisdn) => {
  return axios.post("https://api-mgbmoovgaming.uvcannproducts.com/deactivate-user", {
    msisdn,
  });
};

export const fetchGamesApi = async (language_id = 2) => {
    const response = await axios.get(`${baseUrl}api/games?language_id=${language_id}`);
    return response;
}

export const fetchAndroidGamesApi = async (language_id = 2) => {
    const response = await axios.get(`${baseUrl}api/games/android?language_id=${language_id}`);
    return response;
}

export const loginApi = async (msisdn) => {
  return axios.post(`${baseUrl}login`, { msisdn });
};

export const checkUserApi = async (msisdn) => {
  return axios.get(`${baseUrl}check-user`, {
    params: { msisdn },
  });
};
export const liveLeaderboardApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/live-leaderboard`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const winnersLeaderboardApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/winners`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const userProfileApi = async (token) => {
    const response = await axios.get(`${baseUrl}api/v1/protected/user-profile`, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const editProfileApi = async (formData, token) => {
    const response = await axios.post(`${baseUrl}api/v1/protected/edit-profile`, formData, {
        headers: {
            Authorization: `Bearer ${token}`
        }
    });
    return response;
}

export const SAVE_PLAYTIME_API = `${baseUrl}api/v1/protected/save-play-time`


